import React from 'react';

export default function ShopByConcernSkeleton() {
  return (
    <section className="featured-categories padding-bottom">
      <div className="container">
        <div className="concern">
          {/* This header is now static HTML from the server, which is much faster */}
          <div className="section-header">
            <div className="section-header__content justify-content-sm-center w-100">
              <h2
                className="placeholder "
                style={{
                  width: '350px',
                  height: '16px',
                  borderRadius: '24px',
                }}
              ></h2>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '16px', overflowX: 'auto' }}>
            {Array.from({ length: 5 }).map((_, i) => (
              <div
                className="placeholder "
                key={i}
                style={{
                  minWidth: '230px',
                  height: '250px',
                  borderRadius: '8px',
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
